import BackToTopCom from 'components/common/scroll-to-top';
import WhatsAppFloat from 'components/common/whatsapp-float';
import React, { useEffect } from 'react';
import { animationCreate } from 'utils/utils';

const Wrapper = ({children}) => {
  useEffect(() => {
    setTimeout(() => {
      animationCreate()
    }, 200);
  },[])
  return (
    <>
      {children}
      <WhatsAppFloat />
      <BackToTopCom />
    </>
  );
};

export default Wrapper;